"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var olympus_1 = require("olympus");
var auth_1 = __importDefault(require("./auth"));
var brands_1 = __importDefault(require("./brands"));
var checkout_1 = __importDefault(require("./checkout"));
var customer_1 = __importDefault(require("./customer"));
var v1_1 = __importDefault(require("./delivery/v1"));
var gift_cards_1 = __importDefault(require("./gift-cards"));
var location_1 = __importDefault(require("./location"));
var menu_1 = __importDefault(require("./menu"));
var mobile_app_1 = __importDefault(require("./mobile-app"));
var order_1 = __importDefault(require("./order"));
var special_hours_1 = __importDefault(require("./special-hours"));
__exportStar(require("olympus"), exports);
/**
 * @deprecated Please use generated client
 */
var OwnClient = /** @class */ (function () {
    function OwnClient(_a) {
        var getRequestSettings = _a.getRequestSettings, onError = _a.onError, baseURL = _a.baseURL, _b = _a.guestAudience, guestAudience = _b === void 0 ? 'mercury:guest' : _b;
        var _this = this;
        var headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
        var onResponseError = function (err) { return __awaiter(_this, void 0, void 0, function () {
            var shouldIgnore, cancelErr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(axios_1.default.isAxiosError(err) && onError)) return [3 /*break*/, 3];
                        return [4 /*yield*/, onError(err)];
                    case 1:
                        shouldIgnore = _a.sent();
                        if (!shouldIgnore) return [3 /*break*/, 3];
                        cancelErr = new axios_1.default.Cancel('User logged out');
                        if (Error.captureStackTrace) {
                            Error.captureStackTrace(cancelErr, axios_1.default.Cancel);
                        }
                        return [4 /*yield*/, Promise.reject(cancelErr)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [4 /*yield*/, Promise.reject(err)];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.client = (0, olympus_1.createClient)(baseURL, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getRequestSettings()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }, { onResponseError: onResponseError });
        this.instance = axios_1.default.create({
            baseURL: baseURL,
            headers: headers,
            withCredentials: true,
        });
        this.instance.interceptors.response.use(function (res) { return res; }, onResponseError);
        this.instance.interceptors.request.use(function (req) { return __awaiter(_this, void 0, void 0, function () {
            var _a, audience, client, csrfToken, bearerToken;
            var _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0: return [4 /*yield*/, getRequestSettings()];
                    case 1:
                        _a = _k.sent(), audience = _a.audience, client = _a.client, csrfToken = _a.csrfToken, bearerToken = _a.bearerToken;
                        if (audience) {
                            req.headers['X-PB-Audience'] =
                                (_c = (_b = req.headers) === null || _b === void 0 ? void 0 : _b['X-PB-Audience']) !== null && _c !== void 0 ? _c : audience;
                        }
                        if (client) {
                            req.headers['X-PB-Client'] = (_e = (_d = req.headers) === null || _d === void 0 ? void 0 : _d['X-PB-Client']) !== null && _e !== void 0 ? _e : client;
                        }
                        if (csrfToken) {
                            req.headers['X-CSRFToken'] = (_g = (_f = req.headers) === null || _f === void 0 ? void 0 : _f['X-CSRFToken']) !== null && _g !== void 0 ? _g : csrfToken;
                        }
                        if (bearerToken) {
                            req.headers.authorization = ((_h = req.headers) === null || _h === void 0 ? void 0 : _h.Authorization)
                                ? ["Bearer ".concat(bearerToken), (_j = req.headers) === null || _j === void 0 ? void 0 : _j.Authorization].join(', ')
                                : "Bearer ".concat(bearerToken);
                        }
                        return [2 /*return*/, req];
                }
            });
        }); });
        this.menuAPI = new menu_1.default(this);
        this.locationAPI = new location_1.default(this);
        this.customerAPI = new customer_1.default(this);
        this.deliveryAPI = {
            v1: new v1_1.default(this),
        };
        this.authAPI = new auth_1.default(this, guestAudience);
        this.orderAPI = new order_1.default(this);
        this.brandAPI = new brands_1.default(this);
        this.giftCardAPI = new gift_cards_1.default(this);
        this.specialHoursAPI = new special_hours_1.default(this);
        this.mobileAppAPI = new mobile_app_1.default(this);
        this.checkoutAPI = new checkout_1.default(this);
    }
    /**
     * Performs a GET request
     *
     * @param {string} path URI component
     * @param {object} params URL query params
     * @param {object} config custom axios config
     * @returns {Promise} an API request promise
     */
    OwnClient.prototype.get = function (path, params, config) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get(path, __assign({ params: params }, config))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Performs a DELETE request
     *
     * @param {string} path URI component
     * @param {object} params URL query params
     * @param {object} config custom axios config
     * @returns {Promise} an API request promise
     */
    OwnClient.prototype.delete = function (path, params, config) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.delete(path, __assign({ params: params }, config))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Performs a POST request
     *
     * @param {string} path URI component
     * @param {object} params API request body
     * @param {object} config custom axios config
     * @returns {Promise} an API request promise
     */
    OwnClient.prototype.post = function (path, params, config) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post(path, params, config)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * Performs a PUT request
     *
     * @param {string} path URI component
     * @param {object} params API request body
     * @param {object} config custom axios config
     * @returns {Promise} an API request promise
     */
    OwnClient.prototype.put = function (path, params, config) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.put(path, params, config)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Performs a PATCH request
     *
     * @param {string} path URI component
     * @param {object} params API request body
     * @param {object} config custom axios config
     * @returns {Promise} an API request promise
     */
    OwnClient.prototype.patch = function (path, params, config) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.patch(path, params, config)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return OwnClient;
}());
__exportStar(require("./auth/types"), exports);
__exportStar(require("./brands/types"), exports);
__exportStar(require("./checkout/types"), exports);
__exportStar(require("./customer/types"), exports);
__exportStar(require("./delivery/v1/types"), exports);
__exportStar(require("./gift-cards/types"), exports);
__exportStar(require("./location/types"), exports);
__exportStar(require("./menu/types"), exports);
__exportStar(require("./mobile-app/types"), exports);
__exportStar(require("./order/types"), exports);
__exportStar(require("./special-hours/types"), exports);
__exportStar(require("./types"), exports);
exports.default = OwnClient;
//# sourceMappingURL=index.js.map